import axios from "../utils/axios";
// SHER-352 regression fix: the CancelToken must come from the BASE axios (not the
// `../utils/axios` instance, which lacks `.CancelToken`). See utils/cancelToken.
import { cancelTokenFromSignal } from "../utils/cancelToken";
import * as jose from 'jose';
import CryptoJS from 'crypto-js';
import { datalogger } from "../utils/index.jsx";
import { AgendasTypes } from "../constants/types";


export const answerRequest = datalogger((uuidInvestigation, value, keyInvestigationResearcher) => {
    return new Promise((resolve, reject) => {
        const putObject = { answer: value, keyInvestigationResearcher: keyInvestigationResearcher }
        axios.put(import.meta.env.VITE_APP_API_URL + '/researcher/investigation/' + uuidInvestigation + '/answer', putObject, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => { console.log('Catch', err); reject(err); });
    });
});

export const fetchInvestigations = datalogger(() => {
    return new Promise((resolve, reject) => {

        axios.get(import.meta.env.VITE_APP_API_URL + '/researcher/investigation/all', { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => { console.log('Catch', err); reject(err); });
    });
});

export const fetchProfileService = datalogger((uuidInvestigation) => {
    return new Promise((resolve, reject) => {

        axios.get(import.meta.env.VITE_APP_API_URL + '/researcher/profile/' + uuidInvestigation, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => { console.log('Catch', err); reject(err); });
    });
});

export const fetchInvestigation = datalogger((uuid) => {
    return new Promise((resolve, reject) => {

        axios.get(import.meta.env.VITE_APP_API_URL + '/' + localStorage.getItem("type") + '/investigation/' + uuid, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => { console.log('Catch', err); reject(err); });
    });
})

export const searchDrugService = datalogger((searchText, params, signal) => {
    // SHER-564: AutocompleteSherwood passes Object.values(props.params) → [country, uuidInvestigation?].
    // country stays a path segment; uuidInvestigation (when present) becomes a query param so the
    // API also merges the investigation's pharmacy stock into the results.
    const [country, uuidInvestigation] = Array.isArray(params) ? params : [params];
    const query = uuidInvestigation ? '?uuidInvestigation=' + encodeURIComponent(uuidInvestigation) : '';
    return new Promise((resolve, reject) => {

        axios.get(import.meta.env.VITE_APP_API_URL + '/hospital/search/drug/' + country + '/'+searchText + query, { headers: { "Authorization": localStorage.getItem("jwt") }, cancelToken: cancelTokenFromSignal(signal) })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => { console.log('Catch', err); reject(err); });
    });
})

export const searchDrugComponentService = datalogger((searchText, country, signal) => {
    return new Promise((resolve, reject) => {

        axios.get(import.meta.env.VITE_APP_API_URL + '/hospital/search/component/' + country + '/' + searchText, { headers: { "Authorization": localStorage.getItem("jwt") }, cancelToken: cancelTokenFromSignal(signal) })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => { console.log('Catch', err); reject(err); });
    });
});

export const getStatsPerDiagnosisService = datalogger((uuidInvestigation, icdCode, startDate, endDate) => {
    return new Promise((resolve, reject) => {
        axios.get(import.meta.env.VITE_APP_API_URL + '/analytics/' + uuidInvestigation + '/diagnosis/' + icdCode + '/startDate/' + startDate + '/endDate/' + endDate, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => { console.log('Catch', err); reject(err); });
    });
})

export const searchPatientByDiagnosis = datalogger((uuidInvestivation, ictCode) => {
    return new Promise((resolve, reject) => {
        axios.get(import.meta.env.VITE_APP_API_URL + '/researcher/investigation/' + uuidInvestivation + '/patientsbydiagnose/' + ictCode, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => { console.log('Catch', err); reject(err); });
    });
})

export const uploadFile = datalogger((file) => {
    const formData = new FormData();

    formData.append("files", file);
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: import.meta.env.VITE_APP_API_URL + '/files',
            data: formData,
            headers: { "Authorization": localStorage.getItem("jwt"), 'Content-Type': 'multipart/form-data' }
        })
            .then(function (response) {
                //handle success
                console.log(response);
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(function (response) {
                //handle error
                console.log(response);
                reject(response.data);
            });
    });
});

export const getFile = datalogger((fileName) => {

    return new Promise((resolve, reject) => {
        axios.get(import.meta.env.VITE_APP_API_URL + '/files/' + fileName, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => { console.log('Catch', err); reject(err); });
    });
});

export const searchDiagnosticService = datalogger((searchText) => {
    return new Promise((resolve, reject) => {

        axios.get(import.meta.env.VITE_APP_API_URL + '/hospital/search/diagnostic/' + searchText, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => { console.log('Catch', err); reject(err); });
    });
})

export const fetchRecordsPatientFromSurvey = datalogger((uuidInvestigation, patientUUID, surveyUUID) => {
    return new Promise((resolve, reject) => {

        axios.get(import.meta.env.VITE_APP_API_URL + "/researcher/investigation/" + uuidInvestigation + "/submission/" + patientUUID + "/survey/" + surveyUUID, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => { console.log('Catch', err); reject(err); });
    });
});

// SHER-495: fetch one survey's submissions for a patient (full surveyRecords, combos batched).
// Backs the per-survey load used by MATRIX FORM and the treatment chart, replacing the
// all-surveys bulk fetch. NOTE: distinct from the dead `fetchRecordsPatientFromSurvey` above,
// which targets a /submission/:patient/survey/:survey URL that has no GET route.
export const fetchRecordsPatientFromSurveyService = datalogger((uuidInvestigation, patientUUID, surveyUUID) => {
    return new Promise((resolve, reject) => {

        axios.get(import.meta.env.VITE_APP_API_URL + "/researcher/investigation/" + uuidInvestigation + "/patient/" + patientUUID + "/survey/" + surveyUUID + "/submissions", { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => { console.log('Catch', err); reject(err); });
    });
})

export const fetchRecordsSurveysService = datalogger((uuidInvestigation, surveyUUID) => {
    return new Promise((resolve, reject) => {

        axios.get(import.meta.env.VITE_APP_API_URL + "/researcher/investigation/" + uuidInvestigation + "/survey/" + surveyUUID + "/submissions", { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => { console.log('Catch', err); reject(err); });
    });
})


export const fetchRecordsPatientAllSurveysService = datalogger((uuidInvestigation, patientUUID) => {
    return new Promise((resolve, reject) => {

        axios.get(import.meta.env.VITE_APP_API_URL + "/researcher/investigation/" + uuidInvestigation + "/patient/" + patientUUID + "/submissions", { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => { console.log('Catch', err); reject(err); });
    });
})

// SHER-483: slim, paginated metadata for the clinical-history list table (id / Form /
// Created by / Date). No surveyRecords — the per-submission detail is fetched on click.
// Backed by getAllRecordsPatient's ?slim=true mode (SHER-481).
export const fetchPatientSubmissionsSlimService = datalogger((uuidInvestigation, patientUUID, { limit, offset } = {}) => {
    return new Promise((resolve, reject) => {
        const params = new URLSearchParams({ slim: 'true' });
        if (limit !== undefined && limit !== null) params.append('limit', String(limit));
        if (offset !== undefined && offset !== null) params.append('offset', String(offset));
        axios.get(`${import.meta.env.VITE_APP_API_URL}/researcher/investigation/${uuidInvestigation}/patient/${patientUUID}/submissions?${params.toString()}`, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => { console.log('Catch', err); reject(err); });
    });
})

export const fetchSubmissionsAllPatientsInvestigationService = datalogger((uuidInvestigation, surveyUUID) => {
    return new Promise((resolve, reject) => {

        axios.get(import.meta.env.VITE_APP_API_URL + "/researcher/investigation/" + uuidInvestigation + "/submissions", { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => { console.log('Catch', err); reject(err); });
    });
});

export const addPatient = datalogger((uuidInvestigation, patientData) => {
    return new Promise((resolve, reject) => {
        axios.post(import.meta.env.VITE_APP_API_URL + "/researcher/investigation/" + uuidInvestigation + "/patient", patientData, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => {
                console.log('Catch', err);
                reject(err);
            });
    })
});

export const updatePersonalDataPatientService = datalogger((uuidInvestigation, uuidPatient, patientData) => {
    return new Promise((resolve, reject) => {
        axios.put(import.meta.env.VITE_APP_API_URL + "/researcher/investigation/" + uuidInvestigation + "/patient/" + uuidPatient, patientData, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => { console.log('Catch', err); reject(err); });
    })
});

export const getTokenWho = datalogger((lang) => {
    return new Promise((resolve, reject) => {
        axios.get(import.meta.env.VITE_APP_API_URL + "/hospital/token/who/" + lang, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => { console.log('Catch', err); reject(err); });
    })
});

export const postRecordPatientService = datalogger((postObj, uuidInvestigation, patientId, surveyUUID) => {
    return new Promise((resolve, reject) => {

        axios.post(import.meta.env.VITE_APP_API_URL + "/researcher/investigation/" + uuidInvestigation + "/submission/" + patientId + "/survey/" + surveyUUID, postObj, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch((error) => {
                // console.log(error.response);
                // console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                console.log('Catch', error); reject(error);
            });
    });
});

export const addAddendumToSubmissionService = datalogger((uuidInvestigation, idSubmission, body) => {
    return new Promise((resolve, reject) => {
        axios.post(import.meta.env.VITE_APP_API_URL + "/researcher/investigation/" + uuidInvestigation + "/submission/" + idSubmission + "/addendum", { body }, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => { console.log('Catch', err); reject(err); });
    });
});

export const updateRecordPatientService = datalogger((postObj, uuidInvestigation, patientId, surveyUUID, idSubmission) => {
    return new Promise((resolve, reject) => {

        axios.put(import.meta.env.VITE_APP_API_URL + "/researcher/investigation/" + uuidInvestigation + "/patient/" + patientId + "/survey/" + surveyUUID + "/submission/" + idSubmission, postObj, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => { console.log('Catch', err); reject(err); });
    });
});

export const getSubmissionPatientService = datalogger((uuidInvestigation, idSubmission, withRequests) => {
    const queryString = withRequests ? "?findRequests=true" : "";
    return new Promise((resolve, reject) => {
        axios.get(`${import.meta.env.VITE_APP_API_URL}/researcher/investigation/${uuidInvestigation}/submission/${idSubmission}${queryString}`, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => { console.log('Catch', err); reject(err); });

    });
});

/**
 * @deprecated Use getPatientsFromUpdatedDate instead.
 * This function fetches patients by ID pagination, but timestamp-based sync is preferred.
 */
export const getPatientsFromId = datalogger((uuidInvestigation, patientId) => {
    console.warn('getPatientsFromId is deprecated. Use getPatientsFromUpdatedDate for timestamp-based sync instead.');
    // Fallback to fetch all patients from timestamp 0
    return getPatientsFromUpdatedDate(uuidInvestigation, 0);
});

export const deletePatientService = datalogger((uuidInvestigation, uuidPatient) => {
    return new Promise((resolve, reject) => {
        axios.delete(import.meta.env.VITE_APP_API_URL + "/researcher/investigation/" + uuidInvestigation + "/patient/" + uuidPatient, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
});

/**
 * Get patients for an investigation (full snapshot with pagination)
 * 
 * @param {string} uuidInvestigation - Investigation UUID
 * @param {number} lastUpdatedPatient - DEPRECATED: Kept for backward compatibility, but ignored
 * @param {Object} options - Pagination and filtering options
 * @param {number} options.limit - Number of patients per page (default: backend decides)
 * @param {number} options.offset - Starting offset for pagination
 * @param {boolean} options.slim - If true, returns minimal patient data (faster)
 * @returns {Promise} Response with patients array and pagination object (includes latestEventId)
 * 
 * @example
 * // Get first 1000 patients
 * getPatientsFromUpdatedDate(uuid, 0, { limit: 1000, offset: 0 })
 * 
 * // Get next 1000 patients
 * getPatientsFromUpdatedDate(uuid, 0, { limit: 1000, offset: 1000 })
 */
/**
 * Get patients for an investigation (full snapshot)
 * @param {string} uuidInvestigation - Investigation UUID
 * @param {number} lastUpdatedPatient - DEPRECATED: Legacy parameter, ignored by API (kept for backward compatibility)
 * @param {Object} options - Query options
 * @param {number} options.limit - Page size (default: backend decides)
 * @param {number} options.offset - Pagination offset
 * @param {boolean} options.slim - Return slim patient data (no appointments)
 * @returns {Promise} Promise that resolves to { patients: [], pagination: { latestEventId, ... } }
 */
export const getPatients = datalogger((uuidInvestigation, lastUpdatedPatient, options = {}) => {
    return new Promise((resolve, reject) => {
        // Build query parameters for pagination
        const queryParams = new URLSearchParams();
        
        // Add pagination parameters if provided
        if (options.limit !== undefined) {
            queryParams.append('limit', options.limit.toString());
        }
        if (options.offset !== undefined) {
            queryParams.append('offset', options.offset.toString());
        }
        if (options.slim) {
            queryParams.append('slim', 'true');
        }
        
        const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
        // API endpoint: GET /researcher/investigation/:uuid/patients (returns full snapshot)
        const url = `${import.meta.env.VITE_APP_API_URL}/researcher/investigation/${uuidInvestigation}/patients${queryString}`;

        axios.get(url, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => { console.log('Catch', err); reject(err); });
    });
});

// Backward compatibility alias (DEPRECATED: use getPatients instead)
export const getPatientsFromUpdatedDate = getPatients;

/**
 * Fetch patient events since a given event ID (for incremental sync)
 * @param {string} uuidInvestigation - Investigation UUID
 * @param {number} sinceEventId - Get events after this ID (0 for all events)
 * @param {number} limit - Maximum number of events to return (default 1000)
 * @returns {Promise} Response with events array and hasMore flag
 */
export const getPatientEvents = datalogger((uuidInvestigation, sinceEventId, limit = 500) => {
    return new Promise((resolve, reject) => {
        // Backend max 1000 per request
        const safeLimit = Math.min(limit, 1000);
        const url = `${import.meta.env.VITE_APP_API_URL}/researcher/investigation/${uuidInvestigation}/patients/events?sinceEventId=${sinceEventId}&limit=${safeLimit}`;

        axios.get(url, { 
            headers: { "Authorization": localStorage.getItem("jwt") },
            timeout: 30000 // 30 second timeout for large batches
        })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => { 
                if (err.code === 'ECONNABORTED') {
                    console.error('⏱️ Event fetch timeout - batch too large');
                }
                console.log('Catch', err); 
                reject(err); 
            });
    });
});

/**
 * Fetch a single patient by UUID
 * @param {string} uuidInvestigation - Investigation UUID
 * @param {string} patientUuid - Patient UUID
 * @param {Object} [options] - Optional params
 * @param {boolean} [options.forceFromDB] - If true, skip cache and read from DB
 * @returns {Promise} Response with patient data
 */
export const getPatientByUuid = datalogger((uuidInvestigation, patientUuid, options = {}) => {
    return new Promise((resolve, reject) => {
        const params = new URLSearchParams();
        if (options.forceFromDB === true) params.append('forceFromDB', 'true');
        const query = params.toString() ? `?${params.toString()}` : '';
        const url = `${import.meta.env.VITE_APP_API_URL}/researcher/investigation/${uuidInvestigation}/patient/${patientUuid}${query}`;
        
        axios.get(url, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => { 
                console.log('Catch', err); 
                reject(err); 
            });
    });
});

export const resetPassword = datalogger((credentials) => {
    return new Promise((resolve, reject) => {
        axios
            .post("/api/auth/reset-password", credentials)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
});


export const getStatsFirstMonitoring = datalogger((uuidInvestigation, startDate, endDate) => {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/analytics/" + uuidInvestigation + "/startDate/" + startDate + "/endDate/" + endDate + "/firstmonitoring", { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
});

export const getPatientIdFromDepartment = datalogger((uuidInvestigation, uuidDepartment, startDate, endDate) => {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/analytics/" + uuidInvestigation + "/patients/department/" + uuidDepartment + "/startDate/" + startDate + "/endDate/" + endDate, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
});

export const getStatsMostCommonDiagnosis = datalogger((uuidInvestigation, startDate, endDate) => {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/analytics/" + uuidInvestigation + "/most-common-ict/startDate/" + startDate + "/endDate/" + endDate, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
});

export const getStatsActivityService = datalogger((uuidInvestigation, startDate, endDate) => {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/analytics/" + uuidInvestigation + "/activity/startDate/" + startDate + "/endDate/" + endDate, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
});

export const getStatsOutpatients = datalogger((uuidInvestigation, startDate, endDate) => {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/analytics/" + uuidInvestigation + "/outpatients/startDate/" + startDate + "/endDate/" + endDate, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
});

export const getBillingDepartments = datalogger((uuidInvestigation, startDate, endDate) => {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/analytics/" + uuidInvestigation + "/billing/startDate/" + startDate + "/endDate/" + endDate, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
});

export const getTotalBillingInsurances = datalogger((uuidInvestigation, startDate, endDate) => {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/analytics/" + uuidInvestigation + "/billing/insurances/startDate/" + startDate + "/endDate/" + endDate, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
});



export const getSharedResearchersService = datalogger((uuidInvestigation) => {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/researcher/investigation/" + uuidInvestigation + "/researchers", { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
});

export const getAgendasInvestigationService = datalogger((uuidInvestigation, type) => {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/agenda/" + uuidInvestigation + "/" + type, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
});

export const makeAppointmentService = datalogger((uuidInvestigation, typeAgenda, uuidAgenda, uuidPatient, date, idService, phoneNumber, reason, notes, surgeryInfo) => {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let postObj = {
        uuidPatient,
        timestamp: date.getTime(),
        phone : phoneNumber, 
        userTimeZone,
        reasonVisit : reason,
        notes
    }
    if(typeAgenda === AgendasTypes.CONSULTATION){
        postObj.idService = idService;
    }
    else if(typeAgenda === AgendasTypes.SURGERY){
        postObj.idRequest = idService;
    }
    if(surgeryInfo){
        postObj.mainSurgeon = surgeryInfo.mainSurgeon;
        postObj.surgicalTeam = surgeryInfo.surgicalTeam;
    }   
    return new Promise((resolve, reject) => {
        axios
            .post(import.meta.env.VITE_APP_API_URL + "/agenda/" + uuidInvestigation+"/appointment/"+typeAgenda+"/"+uuidAgenda, postObj, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
});

export const makeBulkAppointmentService = datalogger((uuidInvestigation, uuidAgenda, uuidPatient, dates, idService, phoneNumber, reason, notes) => {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const postObj = {
        uuidPatient,
        idService,
        timestamps: dates.map((date) => date.getTime()),
        phone: phoneNumber,
        userTimeZone,
        reasonVisit: reason,
        notes,
    };
    return new Promise((resolve, reject) => {
        axios
            .post(import.meta.env.VITE_APP_API_URL + "/agenda/" + uuidInvestigation + "/appointment/consultation/" + uuidAgenda + "/bulk", postObj, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error.response?.data ?? error);
            });
    });
});


export const getDepartmentsInsvestigationService = datalogger((uuidInvestigation) => {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/departments", { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
});

export const assignUnitToResearcherService = datalogger((uuidInvestigation, uuidResearcher, uuidDepartment) => {
    return new Promise((resolve, reject) => {
        axios
            .post(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/unit/" + uuidDepartment + "/toresearcher", { uuidResearcher }, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
});

export const removeUnitToResearcherService = datalogger((uuidInvestigation, uuidResearcher, uuidUnit) => {
    return new Promise((resolve, reject) => {
        axios
            .delete(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/unit/" + uuidUnit + "/removeresearcher/" + uuidResearcher, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
});



export const deleteDepartmentService = datalogger((uuidInvestigation, department) => {
    return new Promise((resolve, reject) => {
        axios
            .delete(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/department/"+department.uuid, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
});

export const editDepartmentService = datalogger((uuidInvestigation, department) => {
    return new Promise((resolve, reject) => {
        axios
            .put(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/department/"+department.uuid, department, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
});

export const saveDepartmentService = datalogger((uuidInvestigation, department) => {
    return new Promise((resolve, reject) => {
        axios
            .post(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/department", department, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
});

export const saveUnitService = datalogger((uuidInvestigation, uuidDepartment, unit) => {
    return new Promise((resolve, reject) => {
        axios
            .post(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/department/" + uuidDepartment, unit, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
});

export const editUnitService = datalogger((uuidInvestigation, uuidUnit, unit) => {
    return new Promise((resolve, reject) => {
        axios
            .put(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/unit/" + uuidUnit, unit, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
});



export function saveUpdateWardService(uuidInvestigation, uuidDepartment, ward) {
    return new Promise((resolve, reject) => {
        axios
            .put(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/department/" + uuidDepartment + "/ward", ward, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function deleteServiceService(uuidInvestigation, idServiceInvestigation) {
    return new Promise((resolve, reject) => {
        axios.delete(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/service/" + idServiceInvestigation, { headers: { "Authorization": localStorage.getItem("jwt") } })
        .then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
            reject(response.data);
        })
        .catch((error) => {
            reject(error);
        });
    });
}

// SHER-341 / SHER-51: a service that is on a bill can't be deleted; deactivate retires it
// (active=false) so it disappears from the catalogue/pickers while staying on existing bills.
export function deactivateServiceService(uuidInvestigation, idServiceInvestigation) {
    return new Promise((resolve, reject) => {
        axios.put(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/service/" + idServiceInvestigation + "/deactivate", {}, { headers: { "Authorization": localStorage.getItem("jwt") } })
        .then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
            reject(response.data);
        })
        .catch((error) => {
            reject(error);
        });
    });
}

export function deleteWardService(uuidInvestigation, uuidWard) {
    return new Promise((resolve, reject) => {
        axios
            .delete(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/ward/" + uuidWard, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function deleteUnitService(uuidInvestigation, uuidUnit) {
    return new Promise((resolve, reject) => {
        axios
            .delete(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/unit/" + uuidUnit, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}


export function updateBedService(uuidInvestigation, bedInfo) {
    return new Promise((resolve, reject) => {
        axios
            .put(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/bed/" + bedInfo.id, bedInfo, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function deleteBedService(uuidInvestigation, bedInfo) {
    return new Promise((resolve, reject) => {
        axios
            .delete(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/bed/" + bedInfo.id, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function createBedService(uuidInvestigation, uuidWard, bedInfo) {
    return new Promise((resolve, reject) => {
        axios
            .post(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/ward/" + uuidWard + "/bed", bedInfo, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}


export function updateOrderBedsService(uuidInvestigation, uuidWard, bedsReorder) {
    return new Promise((resolve, reject) => {
        axios
            .put(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/ward/" + uuidWard + "/beds", bedsReorder, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}


export function createStayPatientService(uuidInvestigation, idBed, uuidPatient) {
    return new Promise((resolve, reject) => {
        axios
            .post(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/bed/" + idBed + "/stay", { uuidPatient }, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                error.errorCode = 500;
                reject(error);
            });
    });
}

export function transferPatientService(uuidInvestigation, uuidWardDestination, uuidPatient, idTransferBed) {
    return new Promise((resolve, reject) => {
        axios
            .patch(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/patient/" + uuidPatient + "/ward", { 
                "uuidWardDestination": uuidWardDestination,
                "idTransferBed" : idTransferBed
             }, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                error.errorCode = 500;
                reject(error);
            });
    });
}


export function saveResearcherPermissions(uuidInvestigation, permissions) {
    return new Promise((resolve, reject) => {
        axios
            .post(import.meta.env.VITE_APP_API_URL + "/researcher/investigation/" + uuidInvestigation + "/permissions", permissions, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                    console.log("edited user")
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
// add delete researcher here
export function deleteResearcher(uuidInvestigation,uuidDeleteResearcher) {
    // console.log("uuidInvestigation", uuidInvestigation)
    console.log("deleteResearcher service fun")
    return new Promise((resolve, reject) => {
        axios
            .delete(import.meta.env.VITE_APP_API_URL + "/researcher/investigation/" + uuidInvestigation + "/" + uuidDeleteResearcher , { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                    console.log("deleted user",response.data)
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
                console.log(error, "error in deleteing user")
            });
    });
}

export function getWardService(uuidInvestigation, uuidWard) {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/ward/" + uuidWard, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function getPatientStaysService(uuidInvestigation, uuidPatient) {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/stays/" + uuidPatient, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}



export function dischargePatientService(uuidInvestigation, uuidPatient, disposition, deathData) {
    return new Promise((resolve, reject) => {
        axios
            .post(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/discharge", { uuidPatient, disposition, deathData }, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function updatePatientStatusService(uuidInvestigation, uuidPatient, status, deathData) {
    return new Promise((resolve, reject) => {
        axios
            .put(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/patient/" + uuidPatient + "/status", { status, deathData }, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export const deleteSubmission = datalogger((postObj, uuidInvestigation, idSubmission) => {
    return new Promise((resolve, reject) => {

        axios.delete(import.meta.env.VITE_APP_API_URL + "/researcher/investigation/" + uuidInvestigation + "/submission/" + idSubmission, 
        { 
            headers: { "Authorization": localStorage.getItem("jwt") },
            data: postObj
        })
        .then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
            else {
                reject(response.data);
            }
        })
        .catch(err => {
            console.log('Catch', err);
            reject(err); 
        });
    });
});



export const stopTreatmentPatientService = datalogger((postObj, uuidInvestigation, patientId, surveyUUID, idSubmission) => {
    return new Promise((resolve, reject) => {

        axios.put(import.meta.env.VITE_APP_API_URL + "/researcher/investigation/" + uuidInvestigation + "/patient/" + patientId + "/survey/" + surveyUUID + "/submission/" + idSubmission + "/stop", postObj, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.data);
                }
            })
            .catch(err => { console.log('Catch', err); reject(err); });
    });
});
